export const hightToLow = (s) =>
    ({
        low: 0.2 + fxrand(),
        medium: 0.8 + fxrand(),
        high: 1.5 + fxrand(),
    }[s])
    
    export const forNoise = (s) =>
    ({
        low: 1000+ fxrand()*500,
        medium:  800+ fxrand()*200,
        high:  500+ fxrand()*300,
    }[s])

    export const minusToPlus = (s) =>
    ({
        low:  Math.min(-0.5 + fxrand()/10, -0.4),
        medium: Math.min( -0.6 + fxrand()/5, -0.1),
        high: Math.min(0 + fxrand()/3, 0.3),
    }[s])

export const resolution = (s) =>
    ({
        low: 1000,
        medium: Math.floor(1000 + fxrand() * 2000),
        high: Math.floor(3000 + fxrand() * 3000),
    }[s])
export const colorNoise = (s) =>
    ({
        low: Math.floor(1000 + fxrand() * 500),
        medium: Math.floor(500 + fxrand() * 500),
        high: 200,
    }[s])

export const curveOverallComplexity = (s) =>
    ({
        low: 1,
        medium: Math.ceil(fxrand() * 5) * 2 + 1,
        high: Math.ceil(fxrand() * 10) * 2 + 11,
    }[s])

export const size = (s) =>
    ({
        xs: Math.ceil(3 + fxrand() * 5),
        s: Math.ceil(8 + fxrand() * 10),
        m: Math.ceil(18 + fxrand() * 30),
        l: Math.ceil(48 + fxrand() * 10),
        xl: Math.ceil(58 + fxrand() * 30),
    }[s])
